var symphony = symphony || {};

;(function() {

	symphony.givingToolbarContactSubmitted = false;
	symphony.givingToolbar = function() {

		var $body = $('body');

		if(!$body.hasClass('localSite')){
			return;
		}

		var facebookLink = $('.js-facebookLink').find('a').attr('href');
		var givingToolbar = $('.givingToolbar-toolbar');

		if(givingToolbar.length <= 0){
			$('.heroContainer').addClass('no-margin-bottom no-padding-top');
			if($body.hasClass('events') || $body.hasClass('eventsarticles') || $body.hasClass('story')){
				$('div[role="main"]').addClass('noGivingToolbar');
			}
			return;
		}

		if (hearMoreAction == 'hearMoreUrl') {
			$('.js-emailCapture').click(function(e) {
				e = e || window.event;
				e.preventDefault();
				e.stopPropagation();
				popupCenter(hearMoreUrl, 800, 600);
			});
		}
		
		if (hearMoreAction == 'hearMoreForm') {
			$('#emailCapture').find('.facebookLink').attr('href', facebookLink);

			$('.js-emailCapture').magnificPopup({
				type: 'inline',

				fixedContentPos: false,
				fixedBgPos: true,

				overflowY: 'auto',

				closeBtnInside: true,
				preloader: false,

				midClick: true,
				removalDelay: 300,
				mainClass: 'my-mfp-zoom-in',

				callbacks: {
					open: function() {
						if (typeof utag != "undefined") {
							utag.view({
								'event_name' : 'Email Signup: Start', // Event Name
								'link_text' : 'Email Signup: Start', // Link Text
								'page_name' : utag_data.territory_division + ' | modal:email signup', // Page Name
								'site_section' : 'Hear More', // Site Section
								'site_type' : utag_data.site_type, //Site Typelts
								'login_status' : 'Not Logged In', // New - Login Status
								'territory_division' : utag_data.territory_division, // New - Territory Division
								'event_type' : 'email_signup_start', // Event Type
							});
						}
					},
					close: function() {
						$('.hearMore-error').addClass('u-hidden');
					}
				}
			});

			$('body').on('submit', '#emailCapture form', function(e) {
				if (symphony.givingToolbarContactSubmitted) {
					symphony.givingToolbarContactSubmitted = false;
					return;
				}

				e.preventDefault();
				var $elm = $(this);
				
				var btnLocation = $(this).data('btnlocation');
				if (typeof btnLocation == "undefined" || btnLocation == undefined || btnLocation == null || btnLocation == "") {
					btnLocation = $(this).parents('*[class]').attr('class');
					if (btnLocation.indexOf('hero') > -1) {
						btnLocation = 'theater space';
					} else if ($elm.hasClass('donateHeader-goods')) {
						btnLocation = 'Header_Modal';
					}
				}
				if (typeof utag != "undefined") {
					utag.link({
						'event_name' : 'Email Signup: Complete', // Event Name
						'link_text' : 'Email Signup: Complete', // Link Text
						'page_name' : utag_data.territory_division + ' | modal:email signup', // Page Name
						'site_section' : 'Hear More', // Site Section
						'site_type' : utag_data.site_type, //Site Type
						'login_status' : 'Not Logged In', // New - Login Status
						'territory_division' : utag_data.territory_division, // New - Territory Division
						'event_type' : 'email_signup_complete' // Event Type
					}, function() {
						setTimeout(function() {
							symphony.givingToolbarContactSubmitted = true;
							openHearMoreDialog()
							
						}, 600);
					});
				} else {
					symphony.givingToolbarContactSubmitted = true;
					openHearMoreDialog();
				}
				return false;
			});
		}

		function openHearMoreDialog() {
			var newForm = $('#hearMore').clone(); // clones new form with values
			newForm.removeAttr('onsubmit'); // removes validation
			var newIframe = $('<iframe id="newForm-iframe" />'); // create an iframe

			if (symphony.hearMore.submit()) {
				$('body').append(newIframe); // add the iframe to the page
				$(newIframe.contents()[0].body).append(newForm); // add form to iframe
	
				newForm.submit(); // submit the form 
				setTimeout(function() { $('#newForm-iframe').remove(); }, 10000); // remove the iframe
				$('#hearMore').html('<p>Thanks for signing up! We look forward to communicating with you!</p>'); // Replaces dialog form content w/ thank you text
				$('#form-intructions').html('<p></p>');
			}
		}

		function popupCenter(url, w, h) {
			// Fixes dual-screen position                         Most browsers      Firefox
			var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
			var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
		
			var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
			var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
		
			var left = ((width / 2) - (w / 2)) + dualScreenLeft;
			var top = ((height / 2) - (h / 2)) + dualScreenTop;
			var newWindow = window.open(url, '_blank', 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + ',toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,copyhistory=no,resizable=yes');
		
			// Puts focus on the newWindow
			if (window.focus) {
				newWindow.focus();
			}
		}
		
		$('.js-modalClose').on('click', function(){
			$.magnificPopup.close();
		});

		$('.js-volunteerSubmit').on('click', function(){
			$('body').append('\
			<form method="POST" class="u-hidden" action="' + volunteerformUrl + '" target="_blank" id="volunteerForm">\
			<input type="text" name="' + volunteerformZipName + '" value="' + siteAddress.zip + '">\
			<button type="submit" class="btn btn-danger btn-large" id="search" name="search">GO!</button>\
			</form>');
			$('#volunteerForm').submit();
			setTimeout(function() {
				$('#volunteerForm').remove();
			}, 2000);
		});

	};


})();
